import { motion } from "framer-motion";

// Masked line-by-line reveal. lines: array of strings.
export default function RevealText({ lines, className = "", delay = 0.15 }) {
  return (
    <div className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-line">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.95, ease: [0.16, 1, 0.3, 1], delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </div>
  );
}
